module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-reset-linear-9a01404c022c610ac621661bd87469ca.png";